class subscriptionWidget extends HTMLElement {
  constructor() {
    super();

    this.CURRENT_SELLING_PLAN_ID = this.getAttribute(
      "data-current_selling_plan_id"
    );
    this.CURRENT_PRODUCT_ID = this.getAttribute("data-current_product_id");
    this.PRODUCT_FORM = document.querySelector(
      `form#product_form_${this.CURRENT_PRODUCT_ID}`
    );

    this.querySelector(".delivery__options").addEventListener(
      "change",
      this.changeSellingPlan.bind(this)
    );
    this.querySelectorAll(".purchase-option").forEach((option) =>
      option.addEventListener("click", () => this.changePurchaseType(option))
    );

    // Stiletto's variant handler rewrites .product__price [data-price] to the
    // one-time price on a scent change; re-apply the selected option's price.
    document.addEventListener("product:variant-change", () =>
      this.applyDynamicPrice()
    );

    this.changePurchaseType(this.querySelector(".purchase-option.selected"));
  }

  changeSellingPlan(event) {
    this.CURRENT_SELLING_PLAN_ID = event.target.value;
    const selling_plan = this.CURRENT_SELLING_PLAN_ID;

    // Remove selling_plan element
    this.PRODUCT_FORM.querySelectorAll('input[name="selling_plan"]').forEach(
      (element) => (element.value = selling_plan)
    );
  }

  changePurchaseType(element) {
    //Update selected class
    this.querySelector(".purchase-option.selected").classList.remove(
      "selected"
    );
    element.classList.add("selected");

    //Toggle selling_plan element
    const purchase_type = element.getAttribute("data-purchase_type");

    // Remove selling_plan element
    this.PRODUCT_FORM.querySelectorAll('input[name="selling_plan"]').forEach(
      (element) => element.remove()
    );

    if (purchase_type === "subscription") {
      const SELLING_PLAN_ELEMENT = document.createElement("INPUT");
      SELLING_PLAN_ELEMENT.name = "selling_plan";
      SELLING_PLAN_ELEMENT.type = "hidden";
      SELLING_PLAN_ELEMENT.value = this.CURRENT_SELLING_PLAN_ID;
      this.PRODUCT_FORM.appendChild(SELLING_PLAN_ELEMENT);
    }

    this.applyDynamicPrice();
  }

  applyDynamicPrice() {
    const { enableDynamicPrice } = this.dataset;

    if (enableDynamicPrice == "true") {
      const priceContent = this.querySelector(
        ".purchase-option.selected .purchase-price"
      ).innerHTML;
      const discountPercentContent = this.querySelector(
        ".purchase-option.selected [data-discount-percent]"
      ).innerHTML;
      document
        .querySelectorAll(".product__price [data-price]")
        .forEach((element) => (element.innerHTML = priceContent));
      document
        .querySelectorAll(".product__price [data-discount-display]")
        .forEach((element) => {
          element.innerHTML = element.innerHTML.replace(/\d+%/, discountPercentContent);
        });
      document
        .querySelectorAll(".product__meta .product-badge--sale")
        .forEach((element) => {
          element.innerHTML = element.innerHTML.replace(/\d+%/, discountPercentContent);
        });
    }
  }
}

customElements.define("subscription-widget", subscriptionWidget);



class variantAddToCartButton extends HTMLElement {
  #variantID;

  constructor() {
    super();

    this.#variantID = this.dataset.variantId;
    this.querySelector("button").addEventListener(
      "click",
      this.addItemById.bind(this)
    );
  }

  addItemById() {
    const variantAddToCartEvent = new CustomEvent("cart:additembyid", {
      detail: {
        variantId: this.#variantID,
      },
    });

    document.dispatchEvent(variantAddToCartEvent);
  }
}

customElements.define("variant-add-to-cart", variantAddToCartButton);

class addItemsToCart extends HTMLElement {
  items;

  constructor() {
    super();

    var items = [];

    const ids = this.dataset.variantIds.replace(/\s/gim, "").split(",");

    ids.map((id) => {
      items.push({
        id: id,
        quantity: 1,
      });
    });

    this.items = items;

    this.querySelector("button").addEventListener(
      "click",
      this.addItemById.bind(this)
    );
  }

  addItemById() {
    const itemsAddToCartEvent = new CustomEvent("cart:addItemsToCart", {
      detail: {
        items: this.items,
      },
    });

    document.dispatchEvent(itemsAddToCartEvent);
  }
}

customElements.define("add-items-to-cart", addItemsToCart);

/**
 * Custom Event Hook
 */
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  document
    .querySelectorAll("button.loading")
    .forEach((element) => element.classList.remove("loading"));
});

/**
 * Product Remaining Element
 */
class ProductRemaining extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: "open" });
    this.soldOutLabel = this.dataset.soldOutLabel;
    this.quantity = parseInt(this.dataset.quantity);
    this.available = this.dataset.available === "true";
    this.threshold = parseInt(this.dataset.threshold); // Threshold for showing real inventory

    // Parse the custom variant JSON created in Liquid
    const variantJsonElement = document.querySelector(
      "[data-custom-variant-json]"
    );
    this.variantData = JSON.parse(variantJsonElement.textContent).variants;
  }

  connectedCallback() {
    this.render();

    // Listen for the "product:variant-change" event on document
    document.addEventListener(
      "product:variant-change",
      this.updateVariant.bind(this)
    );
  }

  disconnectedCallback() {
    // Clean up the event listener when the element is removed from the DOM
    document.removeEventListener(
      "product:variant-change",
      this.updateVariant.bind(this)
    );
  }

  updateVariant(event) {
    const variantId = event.detail.variant.id; // Get the variant ID from event.detail.variant
    const variant = this.findVariantById(variantId);
    this.setVariant(variant);
  }

  findVariantById(variantId) {
    return this.variantData.find((variant) => variant.id == variantId);
  }

  setVariant(variant) {
    this.quantity = variant.inventory_quantity || 0;
    this.available = variant.available;
    this.render();
  }

  render() {
    let displayText = "";

    if (!this.available) {
      displayText = this.soldOutLabel;
    } else if (this.quantity > this.threshold) {
      displayText = `Only ${this.calculateFakeQuantity()} Products Left`;
    } else if (this.quantity > 0) {
      displayText = `Only ${this.quantity} Products Left`;
    }

    this.shadowRoot.innerHTML = `
        <p role="heading" aria-level="3" class="prod-remaining">${displayText}</p>
    `;
  }

  calculateFakeQuantity() {
    if (this.quantity < this.threshold) {
      return this.quantity; // Return actual quantity if below the threshold
    }

    const remainder = this.quantity % 200;
    return remainder + this.threshold;
  }
}

customElements.define("product-remaining", ProductRemaining);
